import api from './api';
import Cookies from 'js-cookie';

export default {
  // Obtener órdenes
  getOrders() {
    return api.get('/orders', { withCredentials: true });
  },

  // Crear orden (usado en Step2)
  async createOrder({ sessionState, initialStudentId }) {
    const { data } = await api.post('/orders', { sessionState, initialStudentId }, { withCredentials: true });

    // Si la respuesta incluye sessionId y orderId, configurar las cookies
    if (data.sessionId && data.id) {
      // Configurar cookies con opciones correctas
      Cookies.set("sessionId", data.sessionId, {
        path: '/',
        sameSite: 'Lax', // o 'None' si estás en entornos cruzados con HTTPS
        secure: true     // obligatorio si sameSite es 'None'
      });
      Cookies.set("orderId", data.id, {
        path: '/',
        sameSite: 'Lax',
        secure: true
      });

    }

    return data;
  },

  // Actualizar orden (usado en Step5)
  async updateOrder(data, stepperData = null) {
    let sessionId = '';
    let orderId = 0;

    // Obtener sessionId y orderId desde stepperData si está disponible
    if (stepperData?.step2) {
      sessionId = stepperData.step2.orderData?.sessionId || '';
      orderId = stepperData.step2.orderId || 0;
    }

    // Si tenemos sessionId y orderId, configurar las cookies
    if (sessionId && orderId) {
      Cookies.set("sessionId", sessionId, {
        path: '/',
        sameSite: 'Lax',
        secure: true
      });
      Cookies.set("orderId", orderId, {
        path: '/',
        sameSite: 'Lax',
        secure: true
      });
    }

    // Configurar la petición para enviar cookies
    const config = {
      withCredentials: true
    };

    const { data: response } = await api.put('/orders', data, config);
    return response;
  }
};
